import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { FormField, ResultCard } from './shared';

const Base64Encoder = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [text, setText] = useState('');
  const [res, setRes] = useState('');
  const [mode, setMode] = useState('encode');

  const process = () => {
    try {
      if (mode === 'encode') {
        const encoded = btoa(unescape(encodeURIComponent(text)));
        setRes(encoded);
        onResultChange([{ label: 'Modo', value: 'Codificar' }, { label: 'Resultado', value: encoded }]);
      } else {
        const decoded = decodeURIComponent(escape(atob(text)));
        setRes(decoded);
        onResultChange([{ label: 'Modo', value: 'Decodificar' }, { label: 'Resultado', value: decoded }]);
      }
    } catch (e) {
      setRes('Erro no processamento');
    }
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <FormField label="Modo" value={mode} onChange={setMode} type="select" options={[{ value: 'encode', label: 'Codificar' }, { value: 'decode', label: 'Decodificar' }]} />
        </div>
        <FormField label="Texto" value={text} onChange={setText} type="textarea" />
        <div className="flex justify-center my-6">
          <button onClick={process} className="px-10 py-4 bg-accent-gradient text-white rounded-xl font-bold">Processar</button>
        </div>
        {res && (
          <div className="p-4 bg-theme-input rounded-xl border border-theme-border font-mono text-sm">
            <div className="flex justify-between items-center mb-2">
              <span className="font-bold text-indigo-600">Resultado:</span>
              <button onClick={() => navigator.clipboard.writeText(res)} className="text-xs text-indigo-600 font-bold">Copiar</button>
            </div>
            <div className="break-all">{res}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Base64Encoder;
